import { getRuntimePublicEnvVariable } from '@/shared/modules/environment';

interface GetBaseUrlDependingOnAspNetCoreEnvsParams {
  Prod: string;
  Test: string;
  Dynamic: string;
  Local?: string;
}

/**
 * Returns the base URL depending on the environments `ASPNETCORE_NAMESPACE` and `ASPNETCORE_ENVIRONMENT` injected in
 * the runtime from k8.
 * It can be `Prod`, `Test`, `Dynamic` for a deployed version of the application, or `Local` for local or serve
 * development.
 */
export const getBaseUrlDependingOnAspNetCoreEnvs = (urls: GetBaseUrlDependingOnAspNetCoreEnvsParams) => {
  const aspNetCoreNamespace = getRuntimePublicEnvVariable('ASPNETCORE_NAMESPACE');
  const aspNetCoreEnvironment = getRuntimePublicEnvVariable('ASPNETCORE_ENVIRONMENT');

  switch (aspNetCoreEnvironment) {
    case 'Prod':
      return new URL(urls['Prod']);
    case 'Test':
      return new URL(urls['Test']);
    case 'Dynamic':
      const dynamicUrl = new URL(urls['Dynamic']);
      dynamicUrl.hostname = `${aspNetCoreNamespace}-${dynamicUrl.hostname}`;
      return dynamicUrl;
    case 'Local':
      const localUrl = urls['Local'];
      return new URL(typeof localUrl === 'string' ? localUrl : urls['Test']);
    default:
      return new URL(urls['Test']);
  }
};

export const addFirstSlash = (value: string) => {
  return value.startsWith('/') ? value : `/${value}`;
};

export const addLastSlash = (value: string) => {
  return value.endsWith('/') ? value : `${value}/`;
};

export const removeLastSlash = (value: string) => {
  return value.endsWith('/') ? value.slice(0, -1) : value;
};

export const removeDuplicateSlashes = (value: string) => {
  return value.replaceAll('//', '/');
};

export const removePathnameSegment = (pathname: string, segment?: string) => {
  return typeof segment === 'string' && segment.length > 0 ? pathname.replace(segment, '') : pathname;
};

export const normalizeUrlBaseValue = (url: string) => {
  return removeLastSlash(url);
};

export const normalizeUrlPathname = (pathname: string) => {
  return removeDuplicateSlashes(removeLastSlash(addFirstSlash(pathname)));
};
